export const isObject = function (item) {
    return item && typeof item === 'object' && !Array.isArray(item);
};
export const mergeDeep = function (target, source) {
    const output = Object.assign({}, target);
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach((key) => {
            if (isObject(source[key])) {
                if (!(key in target)) {
                    Object.assign(output, {
                        [key]: source[key],
                    });
                }
                else {
                    output[key] = mergeDeep(target[key], source[key]);
                }
            }
            else {
                Object.assign(output, {
                    [key]: source[key],
                });
            }
        });
    }
    return output;
};
export const sanitizeHtml = function (markup) {
    // tslint:disable-next-line:no-parameter-reassignment
    markup = markup.replace(/&/g, '&amp;');
    // tslint:disable-next-line:no-parameter-reassignment
    markup = markup.replace(/</g, '&lt;');
    // tslint:disable-next-line:no-parameter-reassignment
    markup = markup.replace(/>/g, '&gt;');
    return markup;
};
export const embedMarkups = function (data) {
    return `<div class="embed"><iframe src="${data.embed}" class="embed-unknown" allowfullscreen="true" ></iframe></div>`;
};
//# sourceMappingURL=utilities.js.map